<div class="customize-fields__inner-container">
  @if (typeView !== 'translationsViewNoEditable' && typeView !== 'translationsViewEditable') {
    <field-type-list-extended
      [field]="customizeFieldList.typeListField"
      [listValues]="customizeFieldList.typeList"
      [preSelectItem]="customizeFieldList.selectedTypeList"
      (itemSelected)="changeOptionOn($event, 'typeList')">
    </field-type-list-extended>
    <div class="customize-fields-switch-form__container">
      <field-type-switch
        [field]="{label: 'customize.multiple'| afTranslate}"
        [small]="true"
        [preSelectItem]="customizeFieldList.field.multiple"
        [disabled]="customizeFieldList.field.isHighlight || customizeFieldList.field.numericalScale || customizeFieldList.disabledFormConfiguration || customizeFieldList.field.isManagerClassificator"
        (itemSelected)="changeOptionOn($event, 'multiple')">
      </field-type-switch>
      @if(!concept.poll && customizeFieldList.field.fieldTypeId === 'list' && typeView !== 'channelView'){
        <field-type-switch
          [field]="{label: 'customize.open'| afTranslate}"
          [small]="true"
          [preSelectItem]="customizeFieldList.field.isOpen"
          [disabled]="customizeFieldList.field.noEditable || customizeFieldList.field.isHighlight || customizeFieldList.field.extendedList || customizeFieldList.field.numericalScale || concept.poll || customizeFieldList.disabledFormConfiguration"
          (itemSelected)="changeOptionOn($event, 'isOpen')">
        </field-type-switch>
      }
      <field-type-switch
        [field]="{label: 'customize.code-color'| afTranslate}"
        [small]="true"
        [preSelectItem]="customizeFieldList.field.isHighlight"
        [disabled]="customizeFieldList.field.extendedList || customizeFieldList.field.numericalScale || customizeFieldList.disabledFormConfiguration || customizeFieldList.field.isOpen || customizeFieldList.field.multiple"
        (itemSelected)="changeOptionOn($event, 'isHighlight')">
      </field-type-switch>
    </div>
  }
  <div class="common-text-input__container">
    <div class="common-text-input__container-box-configure-custom"
      [ngClass]="{'common-text-input__container-box-configure-custom--error': customizeFieldList.errorListElements || customizeFieldList.errorEmptyList}"
      [attr.disabled]="customizeFieldList.disabledFormConfiguration?true:null">
      <div class="common-text-input__block-header">
        <div class="common-text-input__label-no-cursor">
          <span class="common-text-input__text-label"
            [afTranslate]="'customize.list-values'">_Valores de la lista</span>
          <span class="common-tag__mandatory-text-asterisk">*</span>
        </div>
      </div>
      @if (typeView !== 'translationsViewNoEditable' && typeView !== 'translationsViewEditable') {
        <div class="customize-field-list__default-value-block"
          [ngClass]="{'customize-field-list__default-value-block--disabled': customizeFieldList.disabledFormConfiguration}">
          <span [afTranslate]="'customize.default-value'">Valor por defecto</span>
        </div>
      }
      <div class="customize-field-list__container-list-values">
        <div class="customize-field-list__container-list-values"
          cdkDropList
          [cdkDropListData]="customizeFieldList.field.listValues"
          (cdkDropListDropped)="reorderContainer($event)">
          @for(listValue of customizeFieldList.field.listValues; track $index){
            <div class="customize-field-list__container-elements-value"
              cdkDrag>
              <div class="customize-field-list__element-value-list"
                [attr.disabled]="customizeFieldList.showNewListValue || (typeView === 'translationsViewEditable' && customizeFieldList.field.numericalScale) || customizeFieldList.disabledFormConfiguration ? true : null">
                @if (typeView !== 'translationsViewNoEditable' && typeView !== 'translationsViewEditable') {
                  <button
                    class="common-button__icon-md-drag-handle"
                    cdkDragHandle
                    [disabled]="customizeFieldList.showNewListValue || customizeFieldList.disabledFormConfiguration"
                    [cdkDragHandleDisabled]="customizeFieldList.showNewListValue || customizeFieldList.disabledFormConfiguration">
                    <i class="lf-icon-arrow-up-down common-icon__md"></i>
                  </button>
                }
                <div class="customize-field-list__items-element-value">
                  <div class="customize-field-list__items-element-value-inner">
                    <div class="common-text-input__field-container">
                      <label class="common-text-input__block-field-input"
                        [ngClass]="{'common-text-input__block-field-input--with-value': listValue.text && !customizeFieldList.disabledFormConfiguration && !customizeFieldList.showNewListValue,
                            'common-text-input__block-field-input--error': listValue.error }"
                        [attr.disabled]="customizeFieldList.showNewListValue || (typeView === 'translationsViewEditable' && customizeFieldList.field.numericalScale) || customizeFieldList.disabledFormConfiguration ? true : null"
                        [for]="'new-value-customize-field-list-'+listValue.listValueId">
                        <input class="common-text-input__input"
                          type="text"
                          autocomplete="off"
                          [id]="'new-value-customize-field-list-'+listValue.listValueId"
                          [name]="'new-value-customize-field-list-'+listValue.listValueId"
                          [placeholder]="'customize-field.add-value' | afTranslate"
                          [(ngModel)]="listValue.text"
                          (keydown.enter)="checkDataValue(listValue, 'text')"
                          (blur)="checkDataValue(listValue, 'text')"
                          [maxLength]="customizeFieldList.maxlength"
                          [disabled]="customizeFieldList.showNewListValue || customizeFieldList.disabledFormConfiguration || (typeView === 'translationsViewEditable' && customizeFieldList.field.numericalScale)"/>
                        @if(listValue.text){
                          <button class="common-text-input__icon-clean-input"
                            tabindex="-1"
                            (click)="listValue.text = ''">
                            <i class="lf-icon-close-thick common-icon__sm"></i>
                          </button>
                        }
                      </label>
                    </div>
                    @if(customizeFieldList.field.fieldTypeId === 'listp'){
                      <div class="common-text-input__block-number">
                        <label class="common-text-input__block-field-input"
                          [ngClass]="{'common-text-input__block-field-input--with-value': listValue.text && !customizeFieldList.disabledFormConfiguration && !customizeFieldList.showNewListValue,
                              'common-text-input__block-field-input--error': listValue.errorWeight}"
                          [attr.disabled]="customizeFieldList.disabledFormConfiguration?true:null"
                          [for]="'new-value-weight-customize-field-list-'+listValue.listValueId">
                          <p-inputNumber class="common-text-input__container-input"
                            styleClass="common-text-input__input-number"
                            [inputId]="'new-value-weight-customize-field-list-'+listValue.listValueId"
                            mode="decimal"
                            [placeholder]="'customize-field.weight' | afTranslate"
                            [useGrouping]="false"
                            [disabled]="customizeFieldList.disabledFormConfiguration"
                            [(ngModel)]="listValue.weight"
                            (onKeyDown)="addDataValue(listValue, 'weight', $event)"
                            (onBlur)="checkDataValue(listValue, 'weight')"></p-inputNumber>
                        </label>
                      </div>
                    }
                    @if(customizeFieldList.field.isHighlight && typeView !== 'translationsViewNoEditable' && typeView !== 'translationsViewEditable'){
                      <div>
                        <div class="common-dropdown-list__button-colors"
                          [attr.disabled]="customizeFieldList.disabledFormConfiguration?true:null"
                          (click)="toggleFilter($event, selectorColorsListValue)">
                          <i [class]="'lf-icon-step-final common-icon__md-code-color-' + (listValue.color | colors:'highlightListColors')"></i>
                          <button class="common-button__icon-sm-noborder"
                            [disabled]="customizeFieldList.disabledFormConfiguration">
                            <i class="common-icon__md"
                              [ngClass]="selectorColorsListValue?.visible?'lf-icon-angle-up':'lf-icon-angle-down'"></i>
                          </button>
                        </div>
                        <p-menu #selectorColorsListValue
                          styleClass="common-dropdown-list__container-colors"
                          appendTo="body"
                          [model]="customizeFieldList.listColors"
                          [popup]="true">
                          <ng-template pTemplate="action"
                            let-color>
                            <button class="common-dropdown-list__si-button"
                              (click)="selectColor(color, listValue)">
                              <i [class]="'lf-icon-step-final common-icon__md-code-color-' + (color.listValueColorId | colors:'highlightListColors')"></i>
                            </button>
                          </ng-template>
                        </p-menu>
                      </div>
                    }
                    @if (typeView !== 'translationsViewNoEditable' && typeView !== 'translationsViewEditable') {
                      <div class="customize-field-list__actions-element-value">
                        <button class="customize-field-list__button-md-trash"
                          (click)="deleteListValue(listValue)">
                          <i class="lf-icon-trash common-icon__md"></i>
                        </button>
                      </div>
                    }
                  </div>
                  @if (typeView !== 'translationsViewNoEditable' && typeView !== 'translationsViewEditable') {
                    <div class="customize-field-list__container-default-value">
                      <button class="customize-field-list__button-md-customize-list"
                        (click)="selectDefaultValue(listValue)"
                        [disabled]="customizeFieldList.showNewListValue || customizeFieldList.disabledFormConfiguration">
                        <i class="common-icon__md"
                          [ngClass]="{'lf-icon-check-full':listValue.isDefaultValue && customizeFieldList.field.multiple,
                                'lf-icon-box-inactive': !listValue.isDefaultValue && customizeFieldList.field.multiple,
                                'lf-icon-radio-button-active':listValue.isDefaultValue && !customizeFieldList.field.multiple,
                                'lf-icon-step-first': !listValue.isDefaultValue && !customizeFieldList.field.multiple}"></i>
                      </button>
                    </div>
                  }
                </div>
              </div>
              @if(listValue.error || listValue.errorWeight){
                <div
                  [ngClass]="{
                    'customize-field-list__container-errors-element--no-padding': typeView === 'translationsViewNoEditable' || typeView === 'translationsViewEditable'
                  }"
                  class="customize-field-list__container-errors-element">
                  <div class="customize-field-list__container-generic-error-element">
                    @if(listValue.error){
                      <div class="common-text-input__mandatory-tag">
                        @if(listValue.errorType === 'numericalScale'){
                          <span [afTranslate]="'customize-field-list.error-numercial-scale-value'"></span>
                        }@else if(listValue.errorType === 'duplicateName'){
                          <span [afTranslate]="'customize-field-list.error-duplicate-value'"></span>
                        }@else {
                          <span [afTranslate]="'customize-field-list.error-empty-value'"></span>
                        }
                      </div>
                    }
                  </div>
                  <div [ngClass]="customizeFieldList.field.isHighlight?'w-[346px]':'w-[270px]'">
                    @if(listValue.errorWeight){
                      <div class="common-text-input__mandatory-tag">
                        <span [afTranslate]="'common.error'">_Error</span>
                      </div>
                    }
                  </div>
                </div>
              }
            </div>
          }
        </div>
        @if(customizeFieldList.showNewListValue){
          <div class="customize-field-list__container-elements-value">
            <div class="customize-field-list__element-value">
              <button class="customize-field-list__button-md-customize-list" disabled>
                <i class="lf-icon-arrow-up-down common-icon__md"></i>
              </button>
              <div class="customize-field-list__items-element-value">
                <div class="customize-field-list__items-element-value-inner">
                  <div class="common-text-input__field-container">
                    <label class="common-text-input__block-field-input"
                      [ngClass]="{'common-text-input__block-field-input--with-value': customizeFieldList.newListValue.text && !customizeFieldList.disabledFormConfiguration,
                          'common-text-input__block-field-input--error': customizeFieldList.newListValue.error }"
                      [attr.disabled]="customizeFieldList.disabledFormConfiguration?true:null"
                      for="new-value-customize-field-list">
                      <input class="common-text-input__input"
                        type="text"
                        autocomplete="off"
                        id="new-value-customize-field-list"
                        name="new-value-customize-field-list"
                        [placeholder]="'customize-field.add-value' | afTranslate"
                        [(ngModel)]="customizeFieldList.newListValue.text"
                        (keydown.enter)="checkDataValue(customizeFieldList.newListValue, 'text')"
                        (blur)="checkDataValue(customizeFieldList.newListValue, 'text')"
                        [maxLength]="customizeFieldList.maxlength"
                        [disabled]="customizeFieldList.disabledFormConfiguration"/>
                      @if(customizeFieldList.newListValue.text){
                        <button class="common-text-input__icon-clean-input"
                          tabindex="-1"
                          (click)="customizeFieldList.newListValue.text = ''">
                          <i class="lf-icon-close-thick common-icon__sm"></i>
                        </button>
                      }
                    </label>
                  </div>
                  @if(customizeFieldList.field.fieldTypeId === 'listp'){
                    <div class="common-text-input__block-number">
                      <label class="common-text-input__block-field-input"
                        [ngClass]="{'common-text-input__block-field-input--with-value': customizeFieldList.newListValue.text && !customizeFieldList.disabledFormConfiguration,
                            'common-text-input__block-field-input--error': customizeFieldList.newListValue.errorWeight}"
                        [attr.disabled]="customizeFieldList.disabledFormConfiguration?true:null"
                        for="new-value-weight-customize-field-list">
                        <p-inputNumber class="common-text-input__container-input"
                          styleClass="common-text-input__input-number"
                          [inputId]="'new-value-weight-customize-field-list'"
                          mode="decimal"
                          [placeholder]="'customize-field.weight' | afTranslate"
                          [useGrouping]="false"
                          [disabled]="customizeFieldList.disabledFormConfiguration"
                          [(ngModel)]="customizeFieldList.newListValue.weight"
                          (onKeyDown)="addDataValue(customizeFieldList.newListValue, 'weight', $event)"
                          (onBlur)="checkDataValue(customizeFieldList.newListValue, 'weight')"></p-inputNumber>
                      </label>
                    </div>
                  }
                  @if(customizeFieldList.field.isHighlight){
                    <div>
                      <div class="common-dropdown-list__button-colors"
                        [attr.disabled]="customizeFieldList.disabledFormConfiguration?true:null"
                        (click)="toggleFilter($event, selectorColorsNewList)">
                        <i [class]="'lf-icon-step-final common-icon__md-code-color-' + (customizeFieldList.newListValue.color | colors:'highlightListColors')"></i>
                        <button class="common-button__icon-sm-noborder"
                          [disabled]="customizeFieldList.disabledFormConfiguration">
                          <i class="common-icon__md"
                            [ngClass]="selectorColorsNewList?.visible?'lf-icon-angle-up':'lf-icon-angle-down'"></i>
                        </button>
                      </div>
                      <p-menu #selectorColorsNewList
                        styleClass="common-dropdown-list__container-colors"
                        appendTo="body"
                        [model]="customizeFieldList.listColors"
                        [popup]="true">
                        <ng-template pTemplate="action"
                          let-color>
                          <button class="common-dropdown-list__si-button"
                            (click)="selectColor(color, customizeFieldList.newListValue)">
                            <i [class]="'lf-icon-step-final common-icon__md-code-color-' + (color.listValueColorId | colors:'highlightListColors')"></i>
                          </button>
                        </ng-template>
                      </p-menu>
                    </div>
                  }
                  <div class="customize-field-list__actions-element-value">
                    <button class="customize-field-list__button-md-customize-list"
                      (click)="saveNewListValue(customizeFieldList.newListValue)">
                      <i class="lf-icon-check common-icon__md"></i>
                    </button>
                    @if(customizeFieldList.field.listValues?.length){
                      <button class="customize-field-list__button-md-customize-list"
                        (click)="closeNewListValue()">
                        <i class="lf-icon-close common-icon__md"></i>
                      </button>
                    }
                  </div>
                </div>
                <div class="customize-field-list__container-default-value">
                  <button class="customize-field-list__button-md-customize-list"
                    (click)="customizeFieldList.newListValue.isDefaultValue = !customizeFieldList.newListValue.isDefaultValue"
                    [disabled]="customizeFieldList.disabledFormConfiguration">
                    <i class="common-icon__md"
                      [ngClass]="{'lf-icon-check-full':customizeFieldList.newListValue.isDefaultValue && customizeFieldList.field.multiple,
                            'lf-icon-box-inactive': !customizeFieldList.newListValue.isDefaultValue && customizeFieldList.field.multiple,
                            'lf-icon-radio-button-active':customizeFieldList.newListValue.isDefaultValue && !customizeFieldList.field.multiple,
                            'lf-icon-step-first': !customizeFieldList.newListValue.isDefaultValue && !customizeFieldList.field.multiple}"></i>
                  </button>
                </div>
              </div>
            </div>
            @if(customizeFieldList.newListValue.error || customizeFieldList.newListValue.errorWeight){
              <div class="customize-field-list__container-errors-element">
                <div class="customize-field-list__container-generic-error-element">
                  @if(customizeFieldList.newListValue.error){
                    <div class="common-text-input__mandatory-tag">
                      @if(customizeFieldList.newListValue.errorType === 'numericalScale'){
                        <span [afTranslate]="'customize-field-list.error-numercial-scale-value'"></span>
                      }@else if(customizeFieldList.newListValue.errorType === 'requiredCharacters'){
                        <span [afTranslate]="'common.required-3-characters'"></span>
                      }@else if(customizeFieldList.newListValue.errorType === 'duplicateName'){
                        <span [afTranslate]="'customize-field-list.error-duplicate-value'"></span>
                      }@else {
                        <span [afTranslate]="'customize-field-list.error-empty-value'"></span>
                      }
                    </div>
                  }
                </div>
                <div [ngClass]="customizeFieldList.field.isHighlight?'w-[346px]':'w-[270px]'">
                  @if(customizeFieldList.newListValue.errorWeight){
                    <div class="common-text-input__mandatory-tag">
                      <span [afTranslate]="'common.error'">_Error</span>
                    </div>
                  }
                </div>
              </div>
            }
          </div>
        }
      </div>
      @if (typeView !== 'translationsViewNoEditable' && typeView !== 'translationsViewEditable') {
        <div>
          <button class="common-button__icon-md-border"
            [pTooltip]="'customize-field.new-value' | afTranslate"
            tooltipPosition="top"
            [tooltipDisabled]="customizeFieldList.showNewListValue || customizeFieldList.disabledFormConfiguration"
            (click)="customizeFieldList.showNewListValue = !customizeFieldList.showNewListValue"
            [disabled]="customizeFieldList.showNewListValue || customizeFieldList.disabledFormConfiguration">
            <i class="lf-icon-sum common-icon__md"></i>
          </button>
        </div>
      }
    </div>
    @if(customizeFieldList.errorListElements || customizeFieldList.errorEmptyList){
      <div class="common-text-input__mandatory-tag">
        <span [afTranslate]="customizeFieldList.errorEmptyList?'common.field-mandatory':'customize-field.error-configuration'">_Campo obligatorio</span>
      </div>
    }
  </div>
  @if (typeView !== 'translationsViewNoEditable' && typeView !== 'translationsViewEditable') {
    <div class="customize-fields-switch-form__container">
      <customize-fields-switch-form
        [field]="customizeFieldList.field"
        [small]="true"
        [concept]="concept"
        [isPrivate]="isPrivate"
        [hiddenInLandings]="hiddenInLandings"
        [typeView]="typeView"
        [previewMode]="previewMode"></customize-fields-switch-form>
      @if(!concept.poll && customizeFieldList.field.fieldTypeId !== 'listp' && typeView !== 'channelView'){
        <field-type-switch
          [field]="{label: 'customize-field-list.manager-classificator'| afTranslate}"
          [small]="true"
          [preSelectItem]="customizeFieldList.field.isManagerClassificator"
          [disabled]="customizeFieldList.field.noEditable || customizeFieldList.disabledFormConfiguration || customizeFieldList.field.multiple"
          (itemSelected)="changeOptionOn($event, 'isManagerClassificator')">
        </field-type-switch>
      }
    </div>
  }
</div>
